import { useQuery } from 'react-query';
import PhotographerCalendarApi from './SE360PhotographerBookingApi';
import PhotographerBookingApi from './SE360PhotographerBookingApi';
import moment from 'moment';

const useSE360DuskPhotographyBookingQueries = (
    orderId,
    bookingDate,
    orderCommandForBooking,
    executionTime
) => {
    const bookingInfo = orderId
        ? useQuery(['booking info', bookingDate], () =>
              PhotographerCalendarApi.getBookingInfo(bookingDate, orderId)
          )
        : null;

    const {
        data: addressCoordinates,
        isLoading: addressCoordinatesIsLoading,
        isError: addressCoordinatesIsError,
        error: addressCoordinatesError
    } = useQuery(['addressCoordinates', bookingDate, bookingInfo, { refetchOnMount: false }], () =>
        getAddressCoordinates()
    );

    let latitude = addressCoordinates ? addressCoordinates['latitude'] : null;
    let longitude = addressCoordinates ? addressCoordinates['longitude'] : null;

    const getPhotographersForDuskBooking = () => {
        let isNewOrder = Boolean(orderCommandForBooking);
        if (isNewOrder) {
            return PhotographerCalendarApi.getPhotographersForNewDuskBooking(
              bookingDate,
              orderCommandForBooking.address.addressLine1,
              orderCommandForBooking.address.addressPostalNumber,
              orderCommandForBooking.address.addressCity,
              executionTime !== null ? executionTime : orderCommandForBooking.executionTime,
              orderCommandForBooking.products,
              orderCommandForBooking.brokerFirmId,
              orderCommandForBooking.numberOfMeasuredPlans,
              latitude,
              longitude
            );
        }
        
        let isRebooking = Boolean(bookingInfo && bookingInfo.data);
        if (isRebooking) {
            return PhotographerBookingApi.getPhotographersForDuskRebooking(
              bookingDate,
              orderId,
              bookingInfo.data.executionTime,
            )
        }
        
        // Twilight Zone
        return Promise.resolve([]);
    };

    const {
        data: newBooking,
        isLoading: newBookingIsLoading,
        isError: newBookingIsError,
        error: newBookingError
    } = useQuery(['new booking', bookingDate, bookingInfo, { refetchOnMount: false }], () =>
        getPhotographersForDuskBooking()
    );

    const getAddressCoordinates = () => {
        if (bookingInfo && bookingInfo.data) {
            return PhotographerBookingApi.getAddressCoordinates(
                bookingInfo.data.address,
                bookingInfo.data.postalCode,
                bookingInfo.data.city
            );
        } else {
            if (orderCommandForBooking) {
                return PhotographerBookingApi.getAddressCoordinates(
                    orderCommandForBooking.address.addressLine1,
                    orderCommandForBooking.address.addressPostalNumber,
                    orderCommandForBooking.address.addressCity
                );
            }
        }
    };

    let formattedBookingDate = moment(bookingDate).format('YYYY-MM-DD');

    let {
        data: locationData,
        isLoading: locationDataIsLoading,
        isError: locationDataIsError,
        error: locationDataError
    } = useQuery(
        [
            'location data',
            formattedBookingDate,
            bookingInfo,
            { enabled: formattedBookingDate && latitude && longitude, refetchOnMount: false }
        ],
        () =>
            PhotographerCalendarApi.getLocationData(formattedBookingDate, null, latitude, longitude)
    );
    return {
        bookingInfo,
        newBooking,
        locationData,
        newBookingIsLoading,
        newBookingIsError,
        addressCoordinatesIsLoading,
        addressCoordinatesIsError,
        locationDataIsLoading,
        locationDataIsError
    };
};

export default useSE360DuskPhotographyBookingQueries;
